<template>
  <el-row :gutter="20">
    <div class="card image__container">
      <el-row>
        <el-col :span="24" v-if="picture" class="text--center">
          <el-image :src="picture" fit="scale-down" class="image__size">
          </el-image>
        </el-col>
      </el-row>
    </div>
  </el-row>
</template>

<script>
export default {
  props: ["picture", "name", "description", "sponsorship"],
};
</script>

<style scoped>
.card {
  margin: 0.75rem;
  width: 100%;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 2.5rem 3.5rem;
  height: 13.5rem;
}
.image__container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image__size {
  width: 70%;
}
</style>
